import Vue from 'vue'
import Vuex from 'vuex'
// import getters from './getters'
Vue.use(Vuex)

const modulesFiles = require.context('./modules', false, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	const value = modulesFiles(modulePath)
	modules[moduleName] = value.default
	return modules 
}, {})

const store = new Vuex.Store({
	modules,
	getters: {
		routes: state => state.routes,
		msgCount: state => state.msgCount,
		activeIndex: state => state.activeIndex,
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js